/* global axios */
import ApiClient from '../ApiClient';

class SocialMonitoringDashboardAPI extends ApiClient {
  constructor() {
    super('social_monitoring/dashboard', {
      accountScoped: true,
      apiVersion: 'v2',
    });
  }

  // eslint-disable-next-line class-methods-use-this
  #buildParams({
    days,
    profileId,
    platform,
    page,
    sentiment,
    topic,
    sortBy,
    category,
    authorClass,
    emotion,
    sentimentTarget,
  } = {}) {
    const params = {};
    if (days !== undefined) params.days = days;
    if (profileId) params.profileId = profileId;
    if (platform) params.platform = platform;
    if (page !== undefined) params.page = page;
    if (sentiment) params.sentiment = sentiment;
    if (topic) params.topic = topic;
    if (sortBy) params.sortBy = sortBy;
    if (category) params.category = category;
    if (authorClass) params.authorClass = authorClass;
    if (emotion) params.emotion = emotion;
    if (sentimentTarget) params.sentimentTarget = sentimentTarget;
    return { params };
  }

  contentBreakdown(opts) {
    return axios.get(`${this.url}/content_breakdown`, this.#buildParams(opts));
  }

  conversionIndices(opts) {
    return axios.get(`${this.url}/conversion_indices`, this.#buildParams(opts));
  }

  emotionBreakdown(opts) {
    return axios.get(`${this.url}/emotion_breakdown`, this.#buildParams(opts));
  }

  territorialBreakdown(opts) {
    return axios.get(
      `${this.url}/territorial_breakdown`,
      this.#buildParams(opts)
    );
  }

  demographicBreakdown(opts) {
    return axios.get(
      `${this.url}/demographic_breakdown`,
      this.#buildParams(opts)
    );
  }

  territorialSegmentation(opts) {
    return axios.get(
      `${this.url}/territorial_segmentation`,
      this.#buildParams(opts)
    );
  }

  summary(opts) {
    return axios.get(`${this.url}/summary`, this.#buildParams(opts));
  }

  sentiment(opts) {
    return axios.get(`${this.url}/sentiment`, this.#buildParams(opts));
  }

  engagement(opts) {
    return axios.get(`${this.url}/engagement`, this.#buildParams(opts));
  }

  competitors(opts) {
    return axios.get(`${this.url}/competitors`, this.#buildParams(opts));
  }

  topMentioners(opts) {
    return axios.get(`${this.url}/top_mentioners`, this.#buildParams(opts));
  }

  mentions(opts) {
    return axios.get(`${this.url}/mentions`, this.#buildParams(opts));
  }
}

export default new SocialMonitoringDashboardAPI();
